import utils from '@/utils/utils';

export default {
  computed: {
    notification() {
      return this.$store.getters['notification/current'];
    },
  },
  watch: {
    notification: {
      immediate: true,
      handler(data) {
        if (data) {
          const temp = {
            ...data,
            duration: 4500,
          };
          // Handle message
          if (utils.isArray(data.message)) {
            const [str, params] = data.message;
            temp.message = this.$t(str, params || null);
          } else {
            temp.message = this.$t(data.message);
          }
          // temp.onClose = () => {
          //   this.$store.dispatch('notification/remove', temp.id);
          // };
          this.$notify(temp);
          this.$store.dispatch('notification/remove', temp.id);
        }
      },
    },
  },
};
